var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { ChartsStyles, FlexContainer } from './Charts.styles';
import { useWidth } from '../../hooks/useWidth';
import { getLocalPoint } from './utils';
var ChartsContext = React.createContext({
    width: 0,
    containerRef: undefined,
    clearPointXY: function () { },
    pinned: undefined,
    setPinned: function () { }
});
export var useCharts = function () { return React.useContext(ChartsContext); };
export var Charts = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? 'Charts--Container' : _b;
    /**
     * `containerRef` is exposed on `dimensions`
     * this allows access to d3's native methods via
     * `d3.select(dimensions.containerRef.current)`
     */
    var _c = useWidth(), containerRef = _c.containerRef, width = _c.width;
    var _d = React.useState(undefined), pointXY = _d[0], setPointXY = _d[1];
    var _e = React.useState(undefined), pinnedData = _e[0], setPinnedData = _e[1];
    var setPinned = function (id, data) {
        setPinnedData(function (pinned) {
            var updated = pinned !== undefined ? new Map(pinned) : new Map();
            if (data === undefined) {
                updated.delete(id);
            }
            else {
                updated.set(id, data);
            }
            return updated;
        });
    };
    var clearPointXY = React.useCallback(function () {
        setPointXY(undefined);
        setPinnedData(undefined);
    }, []);
    var _f = React.useState({
        width: width,
        containerRef: containerRef,
        pointXY: pointXY,
        clearPointXY: clearPointXY,
        pinned: pinnedData,
        setPinned: setPinned
    }), state = _f[0], setState = _f[1];
    var handleChartsClick = React.useCallback(function (event) {
        var _a;
        var xy = (_a = getLocalPoint(event)) !== null && _a !== void 0 ? _a : undefined;
        if (xy !== undefined) {
            setPointXY(xy);
        }
    }, []);
    React.useEffect(function () {
        setState(function (state) { return (__assign(__assign({}, state), { width: width, pointXY: pointXY, pinned: pinnedData })); });
    }, [width, pointXY, pinnedData]);
    return (React.createElement(ChartsContext.Provider, { value: state },
        React.createElement(ChartsStyles, null,
            React.createElement(FlexContainer, { ref: containerRef, className: className, onClick: handleChartsClick }, width !== 0 ? children : null))));
};
//# sourceMappingURL=Charts.js.map